import * as _  from "lodash";
import CustomEvent from "custom-event";
import ExternalLogger from "core-ui/client/src/app/ExternalLogger";

var deepLinkController = function (
  $cookies,
  $location,
  $scope,
  $state,
  $stateParams,
  $rootScope,
  $window,
  AccuCodeService,
  AuthenticationStatusService,
  DefaultCustomizationRetrService,
  LogoutService,
  IndIdSelectionFactory,
  PreLoginAccuRetrievalService,
  PreLoginContactInfoService,
  PrimaryPlanSelectionFactory,
  ReSetACCUService,
  TransactionAccessRetrService,
  deepLinkFactory,
  redirectService
) {

  /** * Logger. */
  var logger = ExternalLogger.getInstance('deepLinkController');
  var authStatus = {};
  if ($stateParams.featureName)
    $rootScope.featureName = $stateParams.featureName;
  if ($stateParams.gaId) {
    $rootScope.gaId = $stateParams.gaId;
  }

  AuthenticationStatusService.clearCache();
  AuthenticationStatusService.getAuthData().then(function (data) {

    // Local testing adding registered flag for testing PART-45271
    function propertyToBoolean(val) {
      var booleanState = ['false', 'true'].indexOf(val);
      return booleanState >= 0 ? Boolean(booleanState) : val;
    }

    authStatus = _.mapValues(data, propertyToBoolean);

    if (!$rootScope.deeplinkCust) {
      deepLinkFactory.getCustomization.query({ accu: 'Default', featureName: $rootScope.featureName }).$promise.then(
        oncustomizationSuccess
      );
    } else {
      oncustomizationSuccess($rootScope.deeplinkCust);
    }
  });

  var oncustomizationSuccess = function (data) {
    if ($scope.accu != 'Empower' && !$rootScope.deeplinkCust) {
      deepLinkFactory.getCustomization.query({ accu: $scope.accu, featureName: $rootScope.featureName },
        function (data) {
          angular.extend($rootScope.deeplinkCust, data);
        },
        function (response) {
          logger.error('error occured with reading accu specific deepLinkCustomization')
        });
    }

    if (authStatus.authenticated) {
      //unsetting this so the header displays as an "authenticated user"
      $rootScope.showNonAuthHeader = undefined;

      const setDeepLinkCustomization = async (deepLinkDetails) =>
        hasCustomerExperienceCustomization(deepLinkDetails) &&
          (await hasCustomerExperienceAccess(deepLinkDetails.customerExperience))
          ? deepLinkDetails.customerExperience
          : deepLinkDetails;

      const hasCustomerExperienceCustomization = (deepLinkDetails) =>
        deepLinkDetails.hasOwnProperty("customerExperience");

      const hasCustomerExperienceAccess = async (customerExperienceCustomization) =>
        _.includes(
          await TransactionAccessRetrService.query({
            txnCode: customerExperienceCustomization.menuAccessCode,
          }).$promise.then((response) => response),
          "true"
        );

      setDeepLinkCustomization(data).then((customization) => {
        $rootScope.deeplinkCust = customization;

        var jsonPostForDest = {};
        jsonPostForDest.targetTxnCode = $rootScope.deeplinkCust.menuAccessCode;
        jsonPostForDest.newTargetTxnCode = $rootScope.deeplinkCust.newMenuAccessCode
          ? $rootScope.deeplinkCust.newMenuAccessCode
          : null;
        jsonPostForDest.authTxnCodes = $rootScope.deeplinkCust.authTxnCodes;
        jsonPostForDest.newAuthTxnCodes = $rootScope.deeplinkCust.newAuthTxnCodes
          ? $rootScope.deeplinkCust.newAuthTxnCodes
          : null;

        const context = $scope.deeplinkCust.url.split("#")[0];
        const hash = $scope.deeplinkCust.url.split("#")[1];
        jsonPostForDest.deepLinkedUrl = $scope.deepLinkData.params
          ? `${context}?${$scope.deepLinkData.params}#${hash}`
          : $rootScope.deeplinkCust.url;
        jsonPostForDest.newDeepLinkedUrl = $rootScope.deeplinkCust.newUrl
          ? $rootScope.deeplinkCust.newUrl
          : null;

        var gaId = $rootScope.gaId;
        jsonPostForDest.gaID = gaId;

        if (!$scope.evaluateLoggingOut(data)) {
          if (!gaId) {
            deepLinkFactory.getPrimaryPlan.query(
              {},
              function (primaryPlanData) {
                gaId = primaryPlanData.gaId;

                if (gaId) {
                  return IndIdSelectionFactory.retrieveAllPlansWithIndid.query(
                    {},
                    function (data) {
                      let hasMultiplePlans = Object.keys(data.plansMapWithIndid).length > 1;
                      if (hasMultiplePlans) {
                        return redirectService.redirect(
                          {
                            destinationUrl: "d",
                            deepUrl:
                              "participant/#/d/" +
                              $rootScope.featureName,
                            plansMapWithIndid:
                              data.plansMapWithIndid,
                            ...jsonPostForDest,
                          },
                          "ALL"
                        );
                      } else {
                        jsonPostForDest.gaID = gaId;
                        let groupClient = String(primaryPlanData.gaId).split("-");
                        let groupClientId = groupClient[0];
                        globalThis.css.group = primaryPlanData.gaId;
                        globalThis.css.groupClient = groupClientId;

                        let customEvent = new CustomEvent(
                          "handleLoginSetAccountDetails",
                          { detail: global }
                        );
                        window.dispatchEvent(customEvent);

                        $scope.redirectToDeepLinkDest(jsonPostForDest);
                        return;
                      }
                    },
                    function (error) {
                      logger.error("Couldnt retrieve plans available: ", error);
                      return;
                    }
                  );
                } else {
                  jsonPostForDest.gaID = gaId;
                }

                let groupClient = String(primaryPlanData.gaId).split("-");
                let groupClientId = groupClient[0];
                globalThis.css.group = primaryPlanData.gaId;
                globalThis.css.groupClient = groupClientId;

                let customEvent = new CustomEvent(
                  "handleLoginSetAccountDetails",
                  { detail: global }
                );
                window.dispatchEvent(customEvent);

                $scope.redirectToDeepLinkDest(jsonPostForDest);
              },
              function (error) {
                $scope.deepLinkErrorCode = $rootScope.deeplinkCust.errors.code;
                logger.error("primaryPlan error from deeplink ");
              }
            );
          } else {
            $scope.evaluateCurrentSessionAndDeepLink(data, jsonPostForDest);
          }
        }
      });
    } else if (!authStatus.registered && authStatus.authenticated === true) {
      $state.go("register.withoutPin", {
        flowName: "deepLink",
        accu: $scope.accu,
        featureName: $rootScope.featureName,
      });
    } else {
      const search = $location.search();
      $rootScope.deepLinkQueryParams = Object.entries(search);

      $state.go("login", {
        flowName: "deepLink",
        accu: $scope.accu,
      });
    }
  };

  $scope.evaluateLoggingOut = function (data) {
    var loggingOutParamIdx = location.href.indexOf('loggingOut');
    if (loggingOutParamIdx !== -1) {
      var params = (location.href.substring(loggingOutParamIdx, location.href.length)).split('=');
      if (params[1] == 'true') {
        $rootScope.urlRedirect = location.href.substring(0, loggingOutParamIdx - 1);
        LogoutService.logOutServices.query(function (data) {
          LogoutService.logOutPartAuth.query().$promise.then(
            {}, function (data) {
              console.log("success part auth session invalidated:" + data);
              if (!authStatus.registered && authStatus.authenticated === true) {
                $scope.redirectToRegister();
              } else {
                $scope.redirectToLogin();
              }
            }, function (error) {
              console.log("error part auth session invalidated:" + error);
              if (!authStatus.registered && authStatus.authenticated === true) {
                $scope.redirectToRegister();
              } else {
                $scope.redirectToLogin();
              }
            }
          );
        });
        return true;
      }
    }
    return false;
  };

  $scope.redirectToRegister = function () {
    $scope.deleteDataLoggingOut();
    window.location.href = $rootScope.urlRedirect;
    $state.go('register.withoutPin', { flowName: 'deepLink', accu: $scope.accu })
  }

  $scope.redirectToLogin = function () {
    $scope.deleteDataLoggingOut();
    window.location.href = $rootScope.urlRedirect;
    $state.go('login', { flowName: 'deepLink', accu: $scope.accu })
  }

  $scope.deleteDataLoggingOut = function () {
    $cookies.remove("JSESSIONID", {
      path: "/participant-web-services",
    });
    $cookies.remove("JSESSIONID", {
      path: "/participant-authentication",
    });
    $cookies.remove("site_tok", { path: "/participant" });
    $cookies.remove("site_tok", { path: "/" });
    $cookies.remove("X-CSRF-TOKEN", { path: "/" });
    $cookies.remove("PM-INDID-TOKEN", { path: "/" });
    $cookies.remove("PM-PLAN-TOKEN", { path: "/" });
    sessionStorage.removeItem("currentMenuState");
    sessionStorage.removeItem("activeNavItems");
    sessionStorage.removeItem("activeMenuRefOnLastState");
  }

  $scope.evaluateCurrentSessionAndDeepLink = function (data, jsonPostForDest) {
    deepLinkFactory.getPrimaryPlan.query({}, function (primaryPlanData) {
      //checking if deeplink plan is not the same as the primaryplan
      if (!($rootScope.gaId === primaryPlanData.gaId)) {
        //starting to switch context based on the plan from the url
        PrimaryPlanSelectionFactory.retrievePlansAvailableForPrimaryPlan.query({}, function (data) {
          if (data.plansMapWithIndid) {
            for (const [key, value] of Object.entries(data.plansMapWithIndid)) {
              if ($rootScope.gaId === value[0].gaId) {
                //getting data to call the switch service
                var params = {
                  "indId": value[0].indId,
                  "dbName": value[0].dbname,
                  "accuCode": value[0].pptwebAccuCode,
                  "updatedefault": "Y"
                };
                PrimaryPlanSelectionFactory.chooseDefaultAndRefresh.query(params,
                  function (data, headers) {
                    $window.accu = data.data.primaryPlan.accuCode;
                    globalThis.css.accu = data.data.primaryPlan.accuCode;
                    ReSetACCUService.query({ accu: $window.accu }).$promise.then(function (resetAccuData) {
                      //updating cookies with new accu from the switched context
                      $cookies.remove('accu', { path: '/' });
                      $cookies.put('accu', $window.accu, { path: '/' });

                      $cookies.remove('accu', { path: '/participant' });
                      $cookies.put('accu', $window.accu, { path: '/participant' });

                      $cookies.remove('clientAccu', { path: '/' });
                      $cookies.put('clientAccu', $window.accu, { path: '/' });

                      $cookies.remove('clientAccu', { path: '/participant' });
                      $cookies.put('clientAccu', $window.accu, { path: '/participant' });

                      $cookies.remove('PM-ACCU-TOKEN', { path: '/' });

                      $scope.accu = AccuCodeService.getAccuCode();
                      if ($scope.accu) {
                        $rootScope.css.accu = $scope.accu;
                        globalThis.css.accu = $scope.accu;
                      } else {
                        $rootScope.css.accu = $window.accu;
                        globalThis.css.accu = $window.accu;
                      }

                      DefaultCustomizationRetrService.query().$promise.then(function (defaultData) {

                        PreLoginAccuRetrievalService.query({ accu: $scope.accu }).$promise.then(function (preLoginData) {
                          $scope.accuCustomization = angular.extend({}, defaultData, preLoginData);
                          $rootScope.accuSpecificPrimDb = $scope.accuCustomization.primaryDatabase.preLoginPrimaryDB;

                          PreLoginContactInfoService.query({ accu: accu, accuSpecificPrimDb: $rootScope.accuSpecificPrimDb, portalType: 'TOLLFREE' }).$promise.then(function (contactData) {
                            $rootScope.siteContactInfo = contactData;
                            $rootScope.$broadcast('siteContactInfoUpdated', $rootScope.siteContactInfo);
                            $rootScope.$broadcast('loginAuthStatusVerified', $scope.authenticationStatus);
                            $rootScope.$broadcast('customizationUpdated', $scope.accuCustomization);
                            jsonPostForDest.targetTxnCode = $rootScope.deeplinkCust.menuAccessCode;
                            jsonPostForDest.newTargetTxnCode = $rootScope.deeplinkCust.newMenuAccessCode ? $rootScope.deeplinkCust.newMenuAccessCode : null;
                            jsonPostForDest.authTxnCodes = $rootScope.deeplinkCust.authTxnCodes;
                            jsonPostForDest.newAuthTxnCodes = $rootScope.deeplinkCust.newAuthTxnCodes ? $rootScope.deeplinkCust.newAuthTxnCodes : null;
                            jsonPostForDest.deepLinkedUrl = $rootScope.deeplinkCust.url;
                            jsonPostForDest.newDeepLinkedUrl = $rootScope.deeplinkCust.newUrl ? $rootScope.deeplinkCust.newUrl : null;

                            //doing redirection to the deeplink with the switched context
                            $scope.redirectToDeepLinkDest(jsonPostForDest);
                          });
                        });
                      });
                    });
                  },
                  function (error) {
                    $scope.deepLinkErrorCode = $rootScope.deeplinkCust.errors.code;
                    logger.error('Error when switching context for deeplink');
                  }
                );
              }
            }
          }
        });
      } else {
        jsonPostForDest.targetTxnCode = $rootScope.deeplinkCust.menuAccessCode;
        jsonPostForDest.newTargetTxnCode = $rootScope.deeplinkCust.newMenuAccessCode ? $rootScope.deeplinkCust.newMenuAccessCode : null;
        jsonPostForDest.authTxnCodes = $rootScope.deeplinkCust.authTxnCodes;
        jsonPostForDest.newAuthTxnCodes = $rootScope.deeplinkCust.newAuthTxnCodes ? $rootScope.deeplinkCust.newAuthTxnCodes : null;
        jsonPostForDest.deepLinkedUrl = $rootScope.deeplinkCust.url;
        jsonPostForDest.newDeepLinkedUrl = $rootScope.deeplinkCust.newUrl ? $rootScope.deeplinkCust.newUrl : null;
        $scope.redirectToDeepLinkDest(jsonPostForDest);
      }

    }, function (error) {
      $scope.deepLinkErrorCode = $rootScope.deeplinkCust.errors.code;
      logger.error('primaryPlan error from deeplink ');
    });
  };

  $scope.goToUrl = function (targetUrl) {
    $window.location.href = targetUrl;
  };

  $scope.redirectToDeepLinkDest = function (jsonPostForDest) {
    const handleError = () => {
      redirectService.redirect({
        destinationUrl: "participant/accounts/#/",
        flowName: "deepLink"
      });
    };

    deepLinkFactory.getDestination.query(jsonPostForDest, function (data) {
      if (data.deepLinkEligible) {
        var deepLinkURL = location.search
        var urlToBeRedircted = data.destinationUrl ? data.destinationUrl : $scope.deeplinkCust.url;

        urlToBeRedircted = urlToBeRedircted.replace(':queryParams', deepLinkURL);
        urlToBeRedircted = urlToBeRedircted.replace(':indId', data.indID);
        urlToBeRedircted = urlToBeRedircted.replace(':gaId', jsonPostForDest.gaID);
        urlToBeRedircted = urlToBeRedircted.replace(':groupId', jsonPostForDest.gaID);
        $scope.goToUrl("../../" + urlToBeRedircted);
      }
      /**
       * The below if condition is that if the user is coming up with deeplink with seconday plan which is in enrollment then we have to supercede the deeplink and
       * redirect the user to the enrollment flow.
       */
      else if (!data.deepLinkEligible && data.destinationUrl) {
        $scope.goToUrl("../../" + data.destinationUrl);
      } else {
        handleError();
      }
    }, function (response) {
      handleError();
    });
  }
};

deepLinkController.$inject = [
  '$cookies',
  '$location',
  '$scope',
  '$state',
  '$stateParams',
  '$rootScope',
  '$window',
  'AccuCodeService',
  'AuthenticationStatusService',
  'DefaultCustomizationRetrService',
  'LogoutService',
  'IndIdSelectionFactory',
  'PreLoginAccuRetrievalService',
  'PreLoginContactInfoService',
  'PrimaryPlanSelectionFactory',
  'ReSetACCUService',
  'TransactionAccessRetrService',
  'deepLinkFactory',
  'redirectService'
];

export default deepLinkController;